import { filter } from 'lodash';
import { Icon } from '@iconify/react';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import plusFill from '@iconify/icons-eva/plus-fill';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Grid,
  Link
} from '@mui/material';

import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';

// components
import Page from '../components/Page';
import Label from '../components/Label';
import Scrollbar from '../components/Scrollbar';
import SearchNotFound from '../components/SearchNotFound';
import { UserListHead, UserListToolbar, UserMoreMenu, UserSearch } from '../components/_dashboard/user';
//
import USERLIST from '../_mocks_/user';
import Request from '../components/common/Request';
import {  Paths, GetAzurePath, AzurePaths } from '../components/common/Constants';

import '../App.css';

import { useNavigate } from "react-router-dom";
import { useRouter } from "../components/common/use-router.js";
import { CSVLink, CSVDownload } from "react-csv";

import { DataGrid, 
    GridActionsCellItem, 
    GridToolbarContainer,
    GridToolbarExport,
    GridToolbarColumnsButton,
    gridClasses,
    GridToolbarFilterButton
  } from '@mui/x-data-grid';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { FancyCard, fancyCardSize } from '../components/_dashboard/app/FancyCard';
import {
  useParams
} from "react-router-dom";

import {  useTranslation } from 'react-i18next';



// ----------------------------------------------------------------------
  

 import {ReactComponent as Trash}  from "../images/Trash.svg"
import { ElectricScooterRounded } from '@mui/icons-material';

// <img src={ require('./images/button.png') } /> */}




export default function UserMgmt(params) {
  let { q } = useParams();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [actionUserId, setActionUserId] = useState(null);
  const [action, setAction] = useState(null);
  const [orderBy, setOrderBy] = useState('Username');
  const [filterName, setFilterName] = useState(q);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filterChecked, filterSetChecked] = useState([0]);
  const [userList, setUserList] = useState(null);
  const [filteredUsers, setFilteredUsers] = useState(null);
  const navigate = useNavigate ();
  const router = useRouter(); 
  const {t, i18n} = useTranslation();

  
  function CustomToolbar(props) {
    return () => 
      <GridToolbarContainer className={gridClasses.toolbarContainer + " customToolbarCointainer blueOnWhiteContainer"}>
        <GridToolbarColumnsButton className="customButtonStyle columnsButton"></GridToolbarColumnsButton>
        <GridToolbarFilterButton className="customButtonStyle filterButton"></GridToolbarFilterButton>


        <Button
          className="customButtonStyle addUserButton"
          variant="contained"
          component={RouterLink}
          to="/dashboard/users/add"
          startIcon={<Icon icon={plusFill} />} >
          {t("usermgmt_btn_new_user")}
        </Button> 

        <div style={{ "flexGrow" : "1"}}></div>

        <GridToolbarExport className="customButtonStyle exportButton" />



          {/* <Link href="/dashboard/users/add">

         New User
        </Link> */}
      </GridToolbarContainer>
    
  }

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };


  const deleteUser = React.useCallback(
      (id) => () => {
          setActionUserId(id);
          setTimeout(() => {
              setConfirmDialogOpen(true);
              

          //  setUserList((prevRows) => prevRows.filter((row) => row.id !== id));
          });
      },
      [],
  );

  const editUser = React.useCallback(
      (id) => () => {
          setActionUserId(id);
          setTimeout(() => {
            router.push("/dashboard/users/edit/" + id );
          });
      },
      [],
  );
  
  var renderRole = (param) => {
   
    if (param >= 32)
      return t("user_role_ultra_admin");
    else if (param >= 16)
      return t("user_role_super_admin");
    else if (param >= 8)
      return t("user_role_admin");
    else
      return t("user_role_user");
    
  };

  const columns = React.useMemo( () =>   [
      { field: 'name', headerName: t("usermgmt_col_name"), width: 250, 
        renderCell:(params) => {
          if (params.row.PictureChangedAtTicks <= 0){
            return <Stack direction="row"> <Avatar  /> <span className="MuiDataGrid-cell MuiDataGrid-cell--textLeft"> {params.value}</span> </Stack>;
          }
          return  <Stack direction="row"> <Avatar src={GetAzurePath( AzurePaths.UserImageThumb + params.row.UserId)} /> <span className="MuiDataGrid-cell MuiDataGrid-cell--textLeft"> {params.value}</span> </Stack>;
          
        }
      },
      { field: 'Email', headerName: t("usermgmt_col_email"), width: 250 },
      { field: 'ActiveSession', headerName: t("usermgmt_col_aktive_session"), type:"boolean"},
      //{ field: 'CreatedAt', headerName: 'CreatedAt', width: 250 },
      { field: 'CreatedAt', headerName: t("usermgmt_col_created_at"),     
          type: 'dateTime',
          valueGetter: ({ value }) => value && new Date(value),
          width: 130,
          renderCell:(params) => {
            return <div> { params.value.toLocaleString(i18n.language) }</div>
            
          } 
      },
      { field: 'IsVisibleToOthers', headerName: t("usermgmt_col_is_visible_to_others"), type:"boolean"},
      { field: 'Newsletter', headerName: t("usermgmt_col_newsletter"), type:"boolean"},

      { field: 'RidesVisibleToPublic', headerName: t("usermgmt_col_rides_visible"), type:"boolean"},
      { field: 'TotalSlidingMeters', headerName: t("usermgmt_col_total_sliding_meters"), type:"number"},
      { field: 'UserRole', headerName: t("usermgmt_col_userrole"), 
      renderCell:(params) => {
        return <div> 
          { 
          renderRole(params.value)
        }
        </div>
        
      }} ,
      // { field: 'status', headerName: 'status'},
      {
          field: 'actions',
          headerName: t("usermgmt_col_actions"),
          type: 'actions',
          width: 80,
          getActions: (params) => [
              <div>
                  <GridActionsCellItem
                    icon={<EditIcon />}
                    label="Delete"
                    onClick={editUser(params.id)} />
                  <GridActionsCellItem
                    icon={<Trash className="del"/>}
                    label="Delete"
                    onClick={deleteUser(params.id)}/>
              </div>
          ]
      }

  ], [deleteUser, editUser, t]);

  const [sortModel, setSortModel] = React.useState([
    { field: 'name', sort: 'asc' },
  ]);

  // const initialState =  {
  //   filter: {
  //     filterModel: {
  //       items: [{ columnField: 'rating', operatorValue: '>', value: '2.5' }],
  //     },
  //   },
  // };
  
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = userList.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
    setPage(0);
  };


  useEffect(async () =>{
    
    var activeUsers = await Request.Get(Paths.ActiveUsers);



    var result = await Request.Get(Paths.Users);
    
    if (result.ok){
      var data = result.data.Users;
      data.forEach(element => {
        element.id = element.UserId;
        element.name = element.Username;
        if (activeUsers.data.Users.filter(p => p.UserId == element.UserId).length > 0)
          element.ActiveSession = 1;
        else
         element.ActiveSession = 0;
  
        element.avatarUrl = GetAzurePath( AzurePaths.UserImageThumb + element.UserId);
      });
      //userList = result.data;
      //console.log(result.data.Users);
      console.log(data);
      console.log(USERLIST);
      setUserList(data);
      setFilteredUsers(data);
    //  setUserList(USERLIST);
    }

   
  }, []);

  useEffect(() => {

    if (action != null){
      console.log(actionUserId, action);
      if (action === 'delete') {
          setConfirmDialogOpen(true);
      }
      else if (action === 'edit') {
          console.log("navigate");
          
        router.push("/dashboard/user/" + actionUserId );
      }
      setAction(null);
    }
   
  }, [action]);

/* DIALOG */
  const [confirmDialogOpen, setConfirmDialogOpen] = React.useState(false);

  const handleConfirmFailed = async () => {
    setConfirmDialogOpen(false);
    setActionUserId(null);
  };

  const handleConfirmSuccess = async () => {
    setConfirmDialogOpen(false);

    var result = await Request.Delete(Paths.DeleteUser.replace("{id}", actionUserId));
    if (result.ok){
      alert("done");

      var filtered = userList.filter(function(value, index, arr){ 
        return value.id != actionUserId;
      });
      setUserList(filtered);
      setSelected([]);
    }
    setActionUserId(null);
  };

  const addUser = async () => {
    router.push("/dashboard/users/add");
  };
  
  useEffect( () => {
    const timeOutId = setTimeout(() => {
      var filterVar = filterName;
      if (filterVar === undefined){
        filterVar = '';
      }
      var users = filter(userList, (_user) => 
        _user.name.toLowerCase().indexOf(filterVar.toLowerCase()) !== -1 || 
        _user.Email.toLowerCase().indexOf(filterVar.toLowerCase()) !== -1);
       setFilteredUsers( users);
    }, 200);
    return () => clearTimeout(timeOutId);

  }, [filterName, userList]);


  const [filterModel, setFilterModel] = React.useState({items : []});
  const [selectedFilter, setSelectedFilter] = useState("All");

  if (filteredUsers == null){
    return <Page title="User"><Container></Container></Page>
  }

  
  const moreMenuSelection = (id, action) => {
    setActionUserId(id);
    setAction(action);

  };



  const cardClicked = (metric) => {
    
    setSelectedFilter(metric);
    if (metric == 'Newsletter' ) {
      setFilterModel({
        items: [
          {
            columnField: 'Newsletter',
            operatorValue: 'is',
            value: "true",
          },
        ],
      });
    }
    else if (metric == 'ActiveUsers' ) {
      setFilterModel({
        items: [
          {
            columnField: 'ActiveSession',
            operatorValue: 'is',
            value: "true",
          },
        ],
      });
    }
    else{
      setFilterModel({ items: [] });
    }
  };
    


  return (
    <Page title="User" className="userMgmt">


      <Dialog
        open={confirmDialogOpen}
        keepMounted
        onClose={handleConfirmFailed}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{t("usermgmt_delete_user_title")}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {t("usermgmt_delete_user_body")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirmFailed}> {t("cancel")}</Button>
          <Button onClick={handleConfirmSuccess}>{t("delete")}</Button>
        </DialogActions>
      </Dialog>

      <Container maxWidth={false}>


        {/* <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            User
          </Typography>

        </Stack> */}

        { userList != null &&
          <Grid container spacing={2}> 
            <Grid item {... fancyCardSize } > 
              <FancyCard selected={selectedFilter == "All"}  cardClicked={(name) =>  {cardClicked(name); }}  metric={ { Name : "All", Value: userList.length}} />  
            </Grid>
            <Grid item {... fancyCardSize } > 
              <FancyCard selected={selectedFilter == "ActiveUsers"} cardClicked={(name) =>  {cardClicked(name); }}  metric={ { Name : "ActiveUsers", Value: userList.filter(p => p.ActiveSession == 1).length}} />  
            </Grid>
            <Grid item {... fancyCardSize } > 
              <FancyCard selected={selectedFilter == "Newsletter"} cardClicked={(name) =>  {cardClicked(name); }}  metric={ { Name : "Newsletter", Value: userList.filter(p => p.Newsletter == 1).length}} />  
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              
            <UserSearch 
                    filterName={filterName}
                    onFilterName={handleFilterByName}
                  />

            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <Card >




                <Scrollbar className="scrollableDataGrid">
                  <TableContainer>
                      <div style={{ height: 800, width: '100%' }}>
                          { filteredUsers != null && <DataGrid 
                          rows={filteredUsers} 
                          columns={columns}  
                          sortModel={sortModel}
                          onSortModelChange={(model) => setSortModel(model)}
                          filterModel={filterModel}
                          onFilterModelChange={(newFilterModel) => setFilterModel(newFilterModel)}
                          components={{
                            Toolbar: CustomToolbar({ addUserCallBack : addUser }),
                          }} />
                          }
                      </div>
                  </TableContainer>
                </Scrollbar>
              </Card>
            </Grid>
          </Grid>
        }




      </Container>
    </Page>
  );
}
